import React, {useState} from 'react'
import {isEmpty} from 'ramda'
import {makeStyles} from '@material-ui/core/styles'
import {
    Box,
    CssBaseline,
    Button,
    TextField,
    Typography,
} from '@material-ui/core'
import {Formik, Form} from 'formik'
import {connect} from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import {dataActions} from '../../../actions'

import LookupHome from '../../../components/Lookup/LookupHome'

// Images
import selectEvent from '../../../images/selectEvent.svg'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: '86vh',
        overflowY: 'auto',
    },
    swipecontainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: '380px',
        maxWidth: '435px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '300px',
            maxWidth: '90%',
        },
    },
    buttonbox: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(3, 0, 2),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '45%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    lookupButton: {
        margin: theme.spacing(3, 0, 2),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '45%',
    },
    eligibilityText: {
        marginTop: '1rem',
        color: theme.palette.green.medium,
        fontWeight: theme.typography.body1.bold.fontWeight,
    },
}))

const Swipe = props => {
    const classes = useStyles()
    const initialValues = {swipeinfo: ''}
    const {
        token,
        occurrence,
        loadingOccurrence,
        swiperesult,
        swipe,
        clearlookupparams,
        clearlookupresults,
    } = props
    const {eventId, occurId, swipeCount: iniswipecount} = occurrence
    const {fetchingSwipeResult, swipeCount: latestSwipeCount} = swiperesult

    const studentsevent =
        occurrence.isEnrolled === 'Y' ? 'Open to Current Students Only' : ''
    const employeeevemt =
        occurrence.isEmployed === 'Y'
            ? 'Open to Current Employees Only'
            : occurrence.isEmployed === 'F'
            ? 'Open to Current Faculty and Full-time Employees Only'
            : ''
    const studentemployeeevent =
        studentsevent && employeeevemt
            ? 'Open to Current Students & Employees Only'
            : ''

    // Dialog parameters
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        clearlookupparams()
        clearlookupresults()
    }

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {loadingOccurrence ? (
                    <Box
                        className={classes.swipecontainer}
                        style={{alignItems: 'center'}}
                    >
                        <CircularProgress
                            style={{
                                color: '#00853e',
                            }}
                            thickness={3}
                        />
                    </Box>
                ) : (
                    <>
                        {isEmpty(occurrence) ? (
                            <Box className={classes.swipecontainer}>
                                <img src={selectEvent} alt="select event" />
                                <Typography align="center" variant="h5">
                                    Select an Event
                                </Typography>
                                <Typography align="center" variant="body1">
                                    Click any event on the left to
                                </Typography>
                                <Typography align="center" variant="body1">
                                    begin recording swipes.
                                </Typography>
                            </Box>
                        ) : (
                            <Box className={classes.swipecontainer}>
                                <Typography align="left" variant="h4">
                                    {occurrence.occurTitle}
                                </Typography>
                                <Typography
                                    align="left"
                                    variant="body1"
                                    className={classes.eligibilityText}
                                >
                                    {studentemployeeevent ||
                                        studentsevent ||
                                        employeeevemt ||
                                        'Open to Everyone at UNT'}
                                </Typography>
                                <Typography align="left" variant="body1">
                                    {occurrence.occurInstructions}
                                </Typography>
                                <Typography
                                    align="left"
                                    variant="h5"
                                    style={{marginTop: '60px'}}
                                >
                                    Swipes recorded:{' '}
                                    {fetchingSwipeResult ? (
                                        <CircularProgress
                                            style={{color: '#00853e'}}
                                        />
                                    ) : (
                                        latestSwipeCount || iniswipecount
                                    )}
                                </Typography>
                                <Formik
                                    initialValues={initialValues}
                                    onSubmit={async (
                                        values,
                                        {resetForm, setFieldValue}
                                    ) => {
                                        await swipe(
                                            token,
                                            eventId,
                                            occurId,
                                            values.swipeinfo
                                        )
                                        setFieldValue('swipeinfo', '')
                                        resetForm()
                                    }}
                                >
                                    {props => (
                                        <Form onSubmit={props.handleSubmit}>
                                            <TextField
                                                id="swipeinfo"
                                                name="swipeinfo"
                                                label="Swipe, EUID or ID number"
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                                margin="normal"
                                                variant="filled"
                                                value={props.values.swipeinfo}
                                                onBlur={props.handleBlur}
                                                onChange={props.handleChange}
                                            />

                                            <Box className={classes.buttonbox}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    size="medium"
                                                    disabled={
                                                        !props.dirty ||
                                                        props.isSubmitting
                                                    }
                                                    className={
                                                        classes.submitButton
                                                    }
                                                >
                                                    Submit
                                                </Button>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    size="medium"
                                                    disabled={
                                                        props.isSubmitting
                                                    }
                                                    className={
                                                        classes.lookupButton
                                                    }
                                                    onClick={handleOpen}
                                                >
                                                    Lookup
                                                </Button>
                                            </Box>
                                        </Form>
                                    )}
                                </Formik>

                                <Dialog
                                    aria-labelledby="Look Up By Name, Birth Month and Day"
                                    aria-describedby="Lookup Person Modal"
                                    open={open}
                                    scroll="paper"
                                    fullScreen={window.innerWidth < 480}
                                    onClose={handleClose}
                                >
                                    <DialogContent>
                                        <LookupHome
                                            exactMatchFn={'swipe'}
                                            handleClose={handleClose}
                                        />
                                    </DialogContent>
                                </Dialog>
                            </Box>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        occurrence: state.occurrencedata.occurrence,
        loadingOccurrence: state.occurrencedata.loadingOccurrence,
        swiperesult: state.swipedata.swiperesult,
    }
}

const mapDispatchToProps = {
    swipe: (token, eventId, occurId, emplId) =>
        dataActions.swipeRequest(token, eventId, occurId, emplId),
    clearlookupparams: () => dataActions.lookupClearParams(),
    clearlookupresults: () => dataActions.lookupClearResults(),
}

export default connect(mapStateToProps, mapDispatchToProps)(Swipe)
